import {useMemo} from 'react';

import {isPlantingYear, isPlantingYearPlus, shouldBeHarvestYear} from '../mechanics';
import {JeopardyWheel, Status} from '../types';
import {CropId} from './crops';
import {EventId} from './events';

export enum JeopardyWheelId {
  climate_1 = 'climate_1',
  climate_2 = 'climate_2',
  chip_bale = 'chip_bale',
}

const FIRST_WHEEL_EVENT_IDS: JeopardyWheel['eventsIds'] = [
  EventId.flood,
  EventId.new_incentive_scheme,
  EventId.drought,
  EventId.improved_growing,
];

const JEOPARDY_WHEELS: JeopardyWheel[] = [
  {
    id: JeopardyWheelId.climate_1,
    title: 'Spin the Wheel of Fate',
    description:
      'Climate Change is a very real threat to farming and can effect your crop in multiple ways. However, there are new incentive schemes in place to help farmers adapt to these new conditions.',
    eventsIds: FIRST_WHEEL_EVENT_IDS,
    wheelClass: 'bg-jeopardies1',
    canDisplay: (status: Status) => {
      /**
       * Display on year 5 or later, if it should be a harvest year and none of this wheel events have occurred
       * (that means that this wheel wasn't displayed before)
       */
      if (status.currentYear < 5 || !shouldBeHarvestYear(status)) return false;
      const historyCopy = [...status.history];
      historyCopy.pop();
      return !historyCopy.some(historyYear => historyYear.events.some(e => FIRST_WHEEL_EVENT_IDS.includes(e.id)));
    },
  },
  {
    id: JeopardyWheelId.climate_2,
    title: 'Spin the Wheel of Fate',
    description: 'Unfortunately, climate change is still very evident.',
    eventsIds: [EventId.hike_energy_prices, EventId.new_pest, EventId.plantation_fire, EventId.award],
    wheelClass: 'bg-jeopardies2',
    canDisplay: (status: Status) => isPlantingYearPlus(status, 7),
  },
  {
    id: JeopardyWheelId.chip_bale,
    title: 'Spin the Wheel of Fate to find out',
    description: 'How does the Council want your crop delivered?',
    eventsIds: [EventId.chips, EventId.bales],
    wheelClass: 'bg-chipBale',
    canDisplay: (status: Status) => {
      const crop = status.crop;
      return crop?.id === CropId.miscanthus && isPlantingYear(status);
    },
  },
];

export const useJeopardyWheels = (status: Status) => {
  return useMemo(() => JEOPARDY_WHEELS.filter(j => j.canDisplay(status)), [status]);
};
